import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Layout from "../layouts/LayoutDefault.jsx";
import GoogleLogInBtn from "../components/utils/GoogleLogInBtn.jsx";
import { useDispatch } from "react-redux"; // Import useDispatch
import { setToken } from "../store";
import RandomImageBackground from "../components/RandomImageBackgroudn";

const Login = () => {
  const apiUrl = import.meta.env.VITE_API_URL;
  const apiRoute = "login";
  const apiEndpoint = `${apiUrl}${apiRoute}`;

  const navigate = useNavigate();
  const dispatch = useDispatch(); // Hook to dispatch actions to Redux store

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      return setErrorMsg("Fyll i epost");
    }
    if (!password) {
      return setErrorMsg("Fyll i lösenord");
    }

    setIsLoading(true);

    // Make a POST request here
    axios
      .post(
        apiEndpoint,
        new URLSearchParams({
          email: email,
          password: password,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          withCredentials: true,
        },
      )
      .then(() => {
        setErrorMsg(""); // Clear prev errormsgs
        // Mark the user as logged in; the JWT is in an HttpOnly cookie
        dispatch(setToken());
        navigate("/userprofile");
      })
      .catch((error) => {
        // Ensure that error.response and error.response.data are defined before accessing them
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setErrorMsg(error.response.data.message);
        } else {
          // Handle errors where the response is not structured as expected
          console.error("Error response structure:", error); // Log the full error object for debugging
          setErrorMsg("Något blev fel, pröva ladda om sidan och testa igen");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Layout
      title="Logga in"
      description="Logga in på Lokult, har du inte konto? Då kan du skapa ett, helt gratis såklart!"
    >
      <div className="hero min-h-screen">
        <RandomImageBackground />
        <div className="card shrink-0 w-full max-w-sm bg-[#131313]/90 backdrop-blur-md border border-white/10 rounded-2xl shadow-2xl">
          <form className="card-body p-6 sm:p-8 space-y-4">
            <h1 className="text-3xl font-black text-center text-white uppercase tracking-wider">
              Logga in
            </h1>
            {errorMsg && (
              <h4 className="text-error font-semibold text-xs pl-1">{errorMsg}</h4>
            )}
            <div className="pt-2">
              <GoogleLogInBtn />
            </div>

            <div className="form-control">
              <label className="label">
                <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">
                  Epost
                </span>
              </label>
              <input
                onChange={handleEmailChange}
                type="email"
                placeholder="epostadress"
                className="input input-bordered bg-[#181818] border-white/10 focus:border-[#0047ff] text-stone-200 rounded-xl"
                autoComplete="email"
                required
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">
                  Lösenord
                </span>
              </label>
              <input
                onChange={handlePasswordChange}
                type="password"
                placeholder="lösenord"
                className="input input-bordered bg-[#181818] border-white/10 focus:border-[#0047ff] text-stone-200 rounded-xl"
                autoComplete="current-password"
                required
              />
              <label className="label pt-1.5">
                <a
                  href="/forgotpassword"
                  className="text-xs text-stone-400 hover:text-white transition-colors"
                >
                  Glömt lösenordet?
                </a>
              </label>
            </div>
            <div className="form-control mt-6 flex flex-col gap-2">
              <button
                className="btn bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full w-full font-bold uppercase tracking-wider text-xs shadow-[0_4px_15px_rgba(0,71,255,0.3)] transition-transform duration-300 hover:scale-[1.02]"
                onClick={handleSubmit}
              >
                {isLoading ? "Laddar..." : "Login"}
              </button>
              <a
                href="/register"
                className="btn btn-outline border-white/20 text-white hover:bg-neutral-800 rounded-full w-full font-bold uppercase tracking-wider text-xs text-center flex items-center justify-center py-3.5"
              >
                Registrera dig
              </a>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
